module.exports = __webpack_public_path__ + "ecac84c86dea1f8fc5ef63ef958ea32f.jpg";